import { Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[preventFocusOnClick]',
  standalone: false,
})
export class PreventFocusOnClick implements OnDestroy {
  constructor(private el: ElementRef) {
    el.nativeElement.addEventListener('click', () => {
      this.blur();
    });
  }

  blur() {
    this.el.nativeElement.blur();
  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('click', () => {
      this.blur();
    });
  }
}
